import { Chip } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import { Link as RouterLink } from 'react-router-dom';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { quotePartsPath } from 'quotes/routes/routePaths';
import { Variant } from 'theme/enums';

export const VendorQuoteIdCell = ({ value }: ICellRendererParams) => {
  if (!value) {
    return <>{DEFAULT_PLACEHOLDER}</>;
  }

  return (
    <Chip
      variant={Variant.OUTLINED}
      slotProps={{ action: { component: RouterLink, to: quotePartsPath(value) } }}
    >
      {value}
    </Chip>
  );
};
